import { NumericFormat } from "react-number-format"


export const NumericFormatCustom = (param) => {
    return (
        <NumericFormat
        type='text'
        displayType='text'
        thousandSeparator
        isNumericString
        // prefix="₩ "
        value={param.row[param.field]}
      />
    )
}

